// extracted by mini-css-extract-plugin
module.exports = {"item":"Comment_item__69gan","itemIcon":"Comment_itemIcon__vcSze","comment":"Comment_comment__JEa_D"};